export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/header-background-ef268e0b06fa8d48ea1a536e7db644fc.png";